const PORTRAIT_OVERRIDE = `
  @page { size: A4 portrait; }
  @media print {
    html,
    body {
      width: auto !important;
      min-width: 0 !important;
      height: auto !important;
      min-height: 0 !important;
      overflow: visible !important;
    }
  }
`;

const printPortraitFrame = async (printIframe) => {
  const frameDocument = printIframe?.contentDocument;
  const frameWindow = printIframe?.contentWindow;

  if (!frameDocument || !frameWindow) {
    throw new Error("Print window is unavailable");
  }

  // react-to-print 2.x copies external styles after pageStyle. Bootstrap 4's
  // print stylesheet sets A3 and a 992px minimum body width, so append the
  // portrait reset only after every copied stylesheet has finished loading.
  const style = frameDocument.createElement("style");
  style.setAttribute("data-portrait-print-override", "true");
  style.textContent = PORTRAIT_OVERRIDE;
  frameDocument.head.appendChild(style);

  await new Promise((resolve) => frameWindow.requestAnimationFrame(() => resolve()));
  frameWindow.focus();
  frameWindow.print();
};

export default printPortraitFrame;
